/**
 * Actions for the "Organization Links Footer".
 *
 * kustomer           | opens the kustomer chat integration
 */

export const SupportedOrganizationLinkFooterActions = {
  Kustomer: 'kustomer',
};

export function isOrganizationLinkFooterActionSupported(action?: string) {
  return Boolean(
    action &&
      Object.values(SupportedOrganizationLinkFooterActions).includes(action),
  );
}
